module.exports = __webpack_public_path__ + "img/AR.c1b7b7f2.png";